export default {
      id: "crown-solid-usage",
      viewBox: "0 0 640 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#crown-solid",
      toString: function () {
        return this.url;
      }
    }